export default __webpack_public_path__ + "static/media/Idle (2).ac3e9b2e.png";